module.exports = __webpack_public_path__ + "img/image9.469f77dd.png";